import React, {Component} from 'react'
import {connect} from 'react-redux'
import cloneDeep from 'clone-deep'
import classes from './Navigation.module.scss'

import Sticker from '../../components/Sticker/Sticker'
import NavigationMenu from '../../components/NavigationMenu/NavigationMenu'

import {
	setCurrentPage,
	showHiddenPage
} from '../../store/actions/navigation'

import {getPageUrl} from '../../utils/utils'
import * as pagesConfig from '../../config/pages'

const A_CAPITAL_KEY_CODE = 65
const L_CAPITAL_KEY_CODE = 76
let keysMap = {
	[A_CAPITAL_KEY_CODE]: false,
	[L_CAPITAL_KEY_CODE]: false
}

class Navigation extends Component {
	componentDidMount() {
		switch (this.props.location.pathname) {
			case getPageUrl(pagesConfig.URL_LIST_PAGE):
				this.setCurrentPage(pagesConfig.URL_LIST_PAGE)
				break
			case getPageUrl(pagesConfig.ACCOUNT_LIST_PAGE):
				this.setCurrentPage(pagesConfig.ACCOUNT_LIST_PAGE)
				break
			default:
				this.setCurrentPage(pagesConfig.SUBMIT_PAGE)
				break
		}

		document.addEventListener('keypress', this.showHiddenPage);
	}

	showHiddenPage = event => {
		if (event.keyCode in keysMap) {
			keysMap[event.keyCode] = true;

			if (event.shiftKey && keysMap[A_CAPITAL_KEY_CODE] && keysMap[L_CAPITAL_KEY_CODE]) {
				this.props.showHiddenPage()
				document.removeEventListener(event.type, this.showHiddenPage)
			}
		}
	}

	setCurrentPage = page => {
		this.props.setCurrentPage(page)
	}

	prepareNavigationConfig(config) {
		const newConfig = cloneDeep(config)

		newConfig[pagesConfig.URL_LIST_PAGE].count = this.props.urlList.length
		newConfig[pagesConfig.URL_LIST_PAGE].isBlinked = !!this.props.urlList.length
		newConfig[pagesConfig.ACCOUNT_LIST_PAGE].isHidden = !this.props.isHiddenPageShown

		return newConfig
	}

	render() {
		return (
			<Sticker
				className={classes.Navigation__sticker}
			>
				<h1
					className={classes.Navigation__title}
				>
					{this.props.pageTitle}
				</h1>
				<NavigationMenu
					pages={this.prepareNavigationConfig(pagesConfig.pages)}
					setPage={this.setCurrentPage}
					{...this.props}
				/>
			</Sticker>
		)
	}
}

const mapStateToProps = state => ({
	urlList: state.storage.urlList,
	isHiddenPageShown: state.navigation.showHiddenPage,
	pageTitle: `${pagesConfig.pages[state.navigation.page].label} page`
})

const mapDispatchToProps = dispatch => ({
	showHiddenPage: () => dispatch(showHiddenPage()),
	setCurrentPage: page => dispatch(setCurrentPage(page))
})

export default connect(mapStateToProps, mapDispatchToProps)(Navigation)